import type { FC } from 'react';
import { Pressable, StyleSheet, type StyleProp, type ViewStyle } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import NotificationBadge from 'src/presentation/components/atoms/NotificationBadge';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';
import { type SvgIconType } from '@thermenresorts/icons';

interface Props {
	onPress: () => void;
	accessibilityLabel?: string;
	backgroundColor?: string;
	pressedBackgroundColor?: string;
	iconColor?: string;
	icon: SvgIconType;
	iconSize?: number;
	style?: StyleProp<ViewStyle>;
	badge?: number;
	animatesBadgeIn?: boolean;
}

const NavigationButton: FC<Props> = ({
	accessibilityLabel,
	icon,
	iconSize = Dimens.iconSize18,
	backgroundColor = Colors.headerButton,
	pressedBackgroundColor = Colors.headerButtonPressed,
	iconColor = Colors.gray750,
	onPress,
	style,
	badge,
	animatesBadgeIn = false,
}) => {
	return (
		<Pressable
			accessibilityLabel={accessibilityLabel}
			accessibilityRole="button"
			style={({ pressed }) => [
				styles.iconWrapper,
				{ backgroundColor: pressed ? pressedBackgroundColor : backgroundColor },
				style,
			]}
			onPress={onPress}
		>
			<SvgIcon name={icon} size={iconSize} tintColor={iconColor} />
			{badge && badge > 0 ? <NotificationBadge animatesIn={animatesBadgeIn} count={badge} /> : null}
		</Pressable>
	);
};

const styles = StyleSheet.create({
	iconWrapper: {
		height: Dimens.size40,
		width: Dimens.size40,
		borderRadius: Dimens.borderRadius20,
		alignItems: 'center',
		justifyContent: 'center',
	},
});

export default NavigationButton;
